import React from 'react'

const HomeCard = ({className, dataList}) => {
   
  return (
    <>
     <div className="main-slider-div">
        <div className="main-slider-inner-div">
          
          <ul>
            {dataList[0]?.array?.map((res, index) => {
              return (
                <li key={index}  style={{color:`red`,backgroundImage: res?.legacy || res?.gameCode== "98789"  ?`url(${process.env.REACT_APP_MOBILE_URL+res?.image})`:`url(${res?.image})`}}
                className={className}
                
                onClick={() => {
                  if (!isEmpty(user)) {
                    // console.log(key,res?.gameCode);
                      if (!isEmpty(user)) {
                       if (res?.gameTypeCheck == "cricket") {
                        window.open(res?.link, "_self");
                       } else if (res?.gameTypeCheck == "platForm") {
                          launchCasino({
                            platForm: res?.platForm,
                            gameType: res?.gameType,
                            casinoType: res?.casinoType,
                          });
                        
                        }
                        else if (res?.gameType == "egtGame") {
                          launchEGTCasino({
                            platForm: res?.platForm,
                            gameType: res?.gameTypeNew,
                            casinoType: res?.casinoType,
                          });
                        }
                         else {
                          if (
                            res?.platForm !== "" &&
                            res?.gameType !== "" &&
                            res?.casinoType !== ""
                          ) {
                            launchCasino({
                              platForm: res?.platForm,
                              gameType: res?.gameType,
                              casinoType: res?.casinoType,
                            });
                          }
                        }
                      } else {
                        navigate("/login");
                      }
                    
                  } else {
                    navigate("/login");
                  }
                }}>
                  
                </li>
              );
            })}
           
          </ul>
        </div>
      
      </div>
    </>
  )
}

export default HomeCard